module.exports = __webpack_public_path__ + "static/allcellular-3513b833d14a98c30be0952edef5987a.jpeg";